export const CHANGE_FILTER = 'filter/CHANGE_FILTER';



// WEBPACK FOOTER //
// ./src/redux/constants/filter.js